import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const DateRangeSelector = ({ onApply }) => {
  const [startDate, setStartDate] = useState('2026-01-14');
  const [endDate, setEndDate] = useState('2026-01-21');
  const [isCustom, setIsCustom] = useState(false);

  const presetRanges = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 Days', value: 'last7days' },
    { label: 'Last 30 Days', value: 'last30days' },
    { label: 'This Month', value: 'thismonth' },
    { label: 'Last Month', value: 'lastmonth' },
    { label: 'Custom Range', value: 'custom' }
  ];

  const handlePresetClick = (value) => {
    if (value === 'custom') {
      setIsCustom(true);
      return;
    }

    setIsCustom(false);
    const today = new Date('2026-01-21');
    let start, end;

    switch (value) {
      case 'today':
        start = end = today;
        break;
      case 'yesterday':
        start = end = new Date(today.setDate(today.getDate() - 1));
        break;
      case 'last7days':
        end = new Date('2026-01-21');
        start = new Date(end);
        start?.setDate(start?.getDate() - 6);
        break;
      case 'last30days':
        end = new Date('2026-01-21');
        start = new Date(end);
        start?.setDate(start?.getDate() - 29);
        break;
      case 'thismonth':
        start = new Date('2026-01-01');
        end = new Date('2026-01-21');
        break;
      case 'lastmonth':
        start = new Date('2025-12-01');
        end = new Date('2025-12-31');
        break;
      default:
        return;
    }

    const formatDate = (date) => date?.toISOString()?.split('T')?.[0];
    setStartDate(formatDate(start));
    setEndDate(formatDate(end));
    
    if (onApply) {
      onApply({ start: formatDate(start), end: formatDate(end) });
    }
  };

  const handleApplyCustom = () => {
    if (onApply && startDate && endDate) {
      onApply({ start: startDate, end: endDate });
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-18 md:p-24">
      <div className="flex items-center gap-12 mb-18">
        <Icon name="Calendar" size={20} color="var(--color-primary)" strokeWidth={2} />
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
          Date Range
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-8 mb-18">
        {presetRanges?.map((range) => (
          <Button
            key={range?.value}
            variant={isCustom && range?.value === 'custom' ? 'default' : 'outline'}
            size="sm"
            onClick={() => handlePresetClick(range?.value)}
            className="w-full"
          >
            {range?.label}
          </Button>
        ))}
      </div>
      {isCustom && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 pt-18 border-t border-border">
          <Input
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e?.target?.value)}
            max={endDate}
          />
          <Input
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e?.target?.value)}
            min={startDate}
          />
          <div className="md:col-span-2">
            <Button
              variant="default"
              onClick={handleApplyCustom}
              iconName="Check"
              iconPosition="left"
              fullWidth
            >
              Apply Custom Range
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;